import { render, staticRenderFns } from "./GroupSetting.vue?vue&type=template&id=be6f75e2&scoped=true&"
import script from "./GroupSetting.vue?vue&type=script&lang=js&"
export * from "./GroupSetting.vue?vue&type=script&lang=js&"
import style0 from "./GroupSetting.vue?vue&type=style&index=0&id=be6f75e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6f75e2",
  null
  
)

export default component.exports